/** auth — EN source (63 keys). */
export const auth = {
  auth_welcome_title: "Welcome",
  auth_welcome_subtitle: "Sign in or create an account",
  auth_continue_with_email: "Continue with Email",
  auth_or: "or",
  auth_signin_title: "Sign in with Email",
  auth_signin_email_label: "Email",
  auth_signin_email_placeholder: "you@example.com",
  auth_signin_password_label: "Password",
  auth_signin_password_placeholder: "Your password",
  auth_signin_button: "Sign in",
  auth_signin_loading: "Signing in...",
  auth_signin_forgot: "Forgot?",
  auth_signin_no_account: "Don't have an account?",
  auth_signin_create_account: "Create account",
  auth_signup_email_title: "Create account",
  auth_signup_email_subtitle: "Enter your email to get started",
  auth_signup_already_have_account: "Already have an account?",
  auth_signup_password_title: "Create password",
  auth_signup_password_subtitle: "Set a password for your account",
  auth_signup_password_label: "Password",
  auth_signup_password_placeholder: "Min. 8 characters",
  auth_signup_password_change: "Change",
  auth_signup_button: "Create account",
  auth_signup_loading: "Creating account...",
  auth_verify_title: "Verify your email",
  auth_verify_subtitle: "We sent a code to {email}",
  auth_verify_resend: "Didn't receive it?",
  auth_verify_resend_button: "Resend",
  auth_verify_resent: "Code sent!",
  auth_forgot_title: "Forgot password",
  auth_forgot_subtitle: "Enter your email to reset your password",
  auth_forgot_button: "Send code",
  auth_forgot_loading: "Sending code...",
  auth_forgot_back: "Back to sign in",
  auth_reset_title: "Reset password",
  auth_reset_subtitle: "Enter the code sent to {email}",
  auth_reset_password_label: "New password",
  auth_reset_button: "Reset password",
  auth_reset_loading: "Resetting...",
  auth_change_email_title: "Change email",
  auth_change_email_subtitle: "Enter your new email address",
  auth_change_email_current: "Current email",
  auth_change_email_new_label: "New email",
  auth_change_email_new_placeholder: "new@example.com",
  auth_change_email_button: "Continue",
  auth_change_email_loading: "Sending code...",
  auth_change_email_verify_title: "Verify your identity",
  auth_change_email_verify_subtitle: "We sent a code to {email}",
  auth_change_email_verify_new_title: "Verify new email",
  auth_change_email_verify_new_subtitle: "We sent a code to {email}",
  auth_change_email_done_title: "Email updated",
  auth_change_email_done_subtitle: "Your email has been changed to {email}",
  auth_change_email_done_button: "Done",
  auth_dashboard_title: "Dashboard",
  auth_dashboard_subtitle: "You are signed in",
  auth_dashboard_email: "Email",
  auth_dashboard_user_id: "User ID",
  auth_dashboard_email_verified: "Email verified",
  auth_dashboard_yes: "Yes",
  auth_dashboard_no: "No",
  auth_dashboard_signout: "Sign out",
  auth_loading: "Loading...",
  auth_loading_session: "Loading session...",
};
